// KDS-style label for the JSON editor, which is not a KDS input and so does not
// get a label of its own.

import React from 'react';
import PropTypes from 'prop-types';

import { FieldLabel, RequiredMark } from './JsonPayloadInput.styled';

// The JSON editor is not a KDS input, so it does not get a KDS label for free.
const JsonFieldLabel = ({ label }) => (
  <FieldLabel>
    {label}
    <RequiredMark aria-label="Required">
      <svg
        viewBox="0 0 16 16"
        fill="none"
        width="12"
        height="12"
        focusable="false"
      >
        <path
          d="M8 2.5a1 1 0 011 1v3.613l3.184-1.062a1 1 0 01.633 1.898L9.633 9.01 11.8 11.9a1 1 0 01-1.6 1.2L8 10.167 5.8 13.1a1 1 0 11-1.6-1.2l2.168-2.89-3.184-1.061a1 1 0 01.632-1.898L7 7.113V3.5a1 1 0 011-1z"
          fill="currentColor"
        />
      </svg>
    </RequiredMark>
  </FieldLabel>
);

JsonFieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default JsonFieldLabel;
